let productSlider = null;
let quickShopSlider = null;

/**
 * Open Modal javscript trigger
 *
 * */
function openModal(modal, opener) {
  if (modal && opener != undefined) modal.show(opener);
}

/**
 * prevent body Touch event in Touch devices when Overlay is visible
 *
 * @param {event} event - event instance
 */
function bodyTouchMove(event) {
  let currentTarget = event.target;
  if (!currentTarget.closest("[data-touch-moveable]")) {
    event.preventDefault();
    return false;
  }
}

/**
 * Limit the number of times a function is called within defined timeout
 *
 * @param {form} form - Form to serialize
 */
const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

/**
 * Fetch call config
 *
 * @param {string} type - request Accept type
 */
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/**
 * Dropdown component Events and Methods
 *
 * @param {element} element - Dropdown element
 */
function dropDownInit(element) {
  const dropdownParent = element.parentElement;
  const dropdownEle = element;

  ["mouseover", "focusin", "click", "mouseout"].forEach(function (type) {
    if (type == "click") {
      dropdownEle.addEventListener(type, (evt) => {
        evt.stopPropagation();
        let currentTarget = evt.currentTarget;
        let liveTarget = evt.target;
        if (liveTarget.classList.contains("nav-link-title")) {
          let linkHref = currentTarget.getAttribute("data-href");
          if (linkHref) window.location.href = linkHref;
        } else {
          dropdownToggle(dropdownParent);
        }
      });
    } else if (type == "mouseout") {
      dropdownParent.addEventListener(
        type,
        (event) => {
          let mobileContainer = event.currentTarget.closest(
            "[data-touch-moveable]"
          );
          if (!mobileContainer) {
            dropdownHide(dropdownParent);
          }
        },
        true
      );
    } else if (type == "mouseover" || type == "focusin") {
      dropdownParent.addEventListener(type, (event) => {
        let mobileContainer = event.currentTarget.closest(
          "[data-touch-moveable]"
        );
        if (!mobileContainer) {
          dropdownShow(dropdownParent);
        }
      });
      dropdownEle.addEventListener(type, (e) => {
        ChildonFocusChange(dropdownParent);
      });
    }
  });

  dropdownParent.addEventListener("keyup", (event) => {
    if (event.code.toUpperCase() === "ESCAPE") {
      dropdownHide(event.currentTarget, event.type);
    }
    if (event.code.toUpperCase() === "ENTER") {
      dropdownShow(event.currentTarget);
    }
  });

  function dropdownToggle(dropdownParent) {
    setTimeout(function () {
      dropdownParent.classList.contains("open")
        ? dropdownHide(dropdownParent)
        : dropdownShow(dropdownParent);
    }, 50);
  }

  function dropdownShow(dropdownParent) {
    if (!dropdownParent) {
      return;
    }

    dropdownEle.setAttribute("aria-expanded", true);
    if (!dropdownParent.closest('[data-role="drawer"]')) {
      dropdownParent.classList.add("open");
    } else {
      Utility.toggleElement(dropdownParent, "open");
    }
  }

  function dropdownHide(dropdownParent, eventType) {
    if (!dropdownParent) {
      return;
    }

    dropdownEle.setAttribute("aria-expanded", false);
    if (!dropdownParent.closest('[data-role="drawer"]')) {
      dropdownParent.classList.remove("open");
    } else {
      Utility.toggleElement(dropdownParent, "close");
    }

    if (
      eventType == "mouseout" &&
      dropdownParent.parentElement.closest(".dropdown")
    ) {
      dropdownParent.parentElement
        .closest(".dropdown")
        .classList.remove("open");
    }

    let childDropdowns = dropdownParent.querySelectorAll(".dropdown.open");
    if (childDropdowns.length > 0) {
      childDropdowns.forEach((child) => {
        child.classList.remove("open");
        if (child.querySelector('a[data-toggle="open"]'))
          child
            .querySelector('a[data-toggle="open"]')
            .setAttribute("aria-expanded", false);
      });
    }
  }

  function ChildonFocusChange(dropdownParent) {
    let openDropdowns = Array.from(
      dropdownParent.parentElement.querySelectorAll(".dropdown.open")
    );
    let currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      let eleIndex = openDropdowns.indexOf(ele);
      if (eleIndex != currentIndex) {
        dropdownHide(ele);
      }
    });
  }

  let closeBtn = dropdownParent.querySelector(".close-submenu");
  if (closeBtn) {
    closeBtn.addEventListener("click", (event) => {
      event.preventDefault();
      let parentElement = event.currentTarget.closest(".dropdown");
      dropdownToggle(parentElement);
    });
  }
}

const allDropdowns = document.querySelectorAll('a[is="drop-down"]');
allDropdowns.forEach(function (ele) {
  dropDownInit(ele);
});

/**
 * Close SubMenu Dropdowns on Regular Nav Item fous or click
 *
 * @param {element} element - Dropdown element
 */
function defaultNavItem(element) {
  let _this = element;
  ["focusin", "click", "mouseover", "mouseout"].forEach(function (type) {
    _this.addEventListener(type, (e) => {
      e.stopPropagation();
      let currentTarget = e.currentTarget;
      if (!currentTarget.closest("[data-touch-moveable]")) {
        hideDropdown(_this.parentElement);
      }
    });
  });

  _this.addEventListener("touchend", (e) => {
    e.stopPropagation();
  });

  function hideDropdown(dropdownParent) {
    let openDropdowns = Array.from(
      dropdownParent.parentElement.querySelectorAll(".dropdown.open")
    );
    openDropdowns.forEach((ele) => {
      ele.classList.remove("open");
      ele
        .querySelector('[is="drop-down"]')
        .setAttribute("aria-expanded", false);
    });
  }
}

const allDefaultNav = document.querySelectorAll('a[is="simple-menu-item"]');
allDefaultNav.forEach(function (ele) {
  defaultNavItem(ele);
});

/**
 * Website Overlay for Mobile Menu and Cart Drawer
 */
class siteOverlay extends HTMLElement {
  constructor() {
    super();

    this.menuDrawer = document.querySelector("#mobile-menu-drawer");
    this.cartDrawer = document.querySelector("#ajax-cart");
  }

  connectedCallback() {
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents() {
    this.addEventListener("click", this.onClick.bind(this));
    this.addEventListener("touchend", this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   * @param {event} Event instance performed
   */
  onClick(event) {
    if (
      this.cartDrawer &&
      this.cartDrawer.classList.contains("opened-drawer")
    ) {
      document
        .querySelector(".close-ajax--cart")
        .dispatchEvent(new Event("click"));
    }
    if (
      this.menuDrawer &&
      this.menuDrawer.classList.contains("opened-drawer")
    ) {
      document
        .querySelector(".close-mobile--navbar")
        .dispatchEvent(new Event("click"));
    }
    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
  showOverlay() {
    document.getElementById("site-overlay").classList.add("overlay--body");
    document.querySelector("body").classList.add("scroll-fixed");
    document.querySelector("body").setAttribute("data-lenis-prevent", "true");
    document.body.style.overflowY = "hidden";
    // document.body.addEventListener('touchmove', bodyTouchMove, false);
  }

  /**
   * Hide overlay
   */
  hideOverlay() {
    document.getElementById("site-overlay").classList.remove("overlay--body");
    document.querySelector("body").classList.remove("scroll-fixed");
    document
      .querySelector("body")
      .removeAttribute("data-lenis-prevent", "true");
    document.body.style.overflowY = "auto";
    // document.body.removeEventListener('touchmove', bodyTouchMove, false);
    document.querySelectorAll(".modal-local.open").forEach((ele) => {
      ele.closest("modal-dialog").hide()
    })
  }
}
customElements.define("site-overlay", siteOverlay);

/**
 * Slider Component
 *
 */
class sliderElement extends HTMLElement {
  constructor() {
    super();
    this.sliderEle = this.querySelector(".swiper-slider");
  }

  connectedCallback() {
    if (!this.sliderEle) return;

    let sliderOptions = this.sliderEle.getAttribute("data-slider");
    sliderOptions = JSON.parse(sliderOptions);

    // Set up nav slider
    if (this.sliderEle.hasAttribute("data-nav")) {
      let thumbSlider = document.querySelector(
        "." + this.sliderEle.getAttribute("data-nav")
      );
      if (!thumbSlider) {
        return;
      }
      let thumbSliderOptions = thumbSlider.getAttribute("data-slider");
      thumbSliderOptions = JSON.parse(thumbSliderOptions);
      thumbSlider = new Swiper(thumbSlider, thumbSliderOptions);

      sliderOptions.thumbs = {
        swiper: thumbSlider,
      };
    }

    let sliderInstance = new Swiper(this.sliderEle, sliderOptions);
    if (this.sliderEle.classList.contains("product-carousel")) {
      productSlider = sliderInstance;
    } else if (this.sliderEle.classList.contains("quickshop-slider")) {
      quickShopSlider = sliderInstance;
    }

    this.slideChangeEvt(sliderInstance);
  }

  slideChangeEvt(slider) {
    slider.on("slideChange", (event) => {
      const currentTarget = event.el;
      let activeVideos = currentTarget.querySelectorAll(
        ".custom-video-container.playing--video"
      );
      if (activeVideos.length > 0) {
        activeVideos.forEach((container) => {
          let video = container.querySelector("custom-video");
          let videoType = video.getAttribute("data-video-type");
          let videoEle =
            video.querySelector("video") || video.querySelector("iframe");
          if (videoType == "local") {
            videoEle.pause();
          } else if (videoType == "youtube") {
            videoEle.contentWindow.postMessage(
              '{"event":"command","func":"pauseVideo","args":""}',
              "*"
            );
          }
        });
      }
    });
  }
}
let lookForSwiper = setInterval(() => {
  if (typeof Swiper == "function") {
    customElements.define("slider-element", sliderElement);
    clearInterval(lookForSwiper);
  }
}, 100);

/**
 * Custom Video
 */
class customVideo extends HTMLElement {
  constructor() {
    super();

    this.container = this.closest(".custom-video-container");
    this.videoModal = document.getElementById("PopupModal-video");
    this.contentSection = this.querySelector(".content-section");

    this.triggerVideo = this.container.querySelector("[data-trigger-video]");
    this.type = this.getAttribute("data-video-type");
    this.videoURL = this.getAttribute("data-video-id");
    this.placementType = this.getAttribute("data-placement");

    this.videoSection = this.querySelector(".video-section");
    if (this.placementType == "popup")
      this.videoSection = this.videoModal.querySelector(".video-container");
  }

  connectedCallback() {
    this.bindEvents();
  }

  /**
   * Binding events on the video button
   */
  bindEvents() {
    if (this.querySelector("[data-postervideo]")) this.managePosterVideos();
    if (this.triggerVideo) {
      this.triggerVideo.addEventListener("click", this.toggleView.bind(this));
      this.triggerVideo.addEventListener(
        "touchstart",
        this.toggleView.bind(this),
        { passive: true }
      );
    }
    if (this.placementType == "grid")
      this.addEventListener("focusout", this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(event) {
    if (
      this.placementType == "popup" &&
      this.container.classList.contains("playing--video")
    )
      this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(evt) {
    let isOpen = this.container.classList.contains("playing--video");
    if (isOpen) {
      this.videoSection.innerHTML = "";
      this.container.classList.remove("playing--video");
    } else {
      if (typeof YT == "undefined" && this.type == "youtube") {
        let youtubeScript = document.createElement("script");
        youtubeScript.src = "https://www.youtube.com/iframe_api";
        document.body.appendChild(youtubeScript);
      }

      const videoElement = this._buildVideo();
      videoElement.id = "custom-video" + Math.floor(Math.random() * 100 + 1);
      this.videoSection.appendChild(videoElement);

      if (this.type == "local") {
        setTimeout(() => {
          videoElement.play();
        }, 500);
      }

      const addClassInterval = setInterval(() => {
        if (this.videoSection.innerHTML != "") {
          if (this.placementType == "popup") {
            openModal(this.videoModal, this.triggerVideo);
          } else {
            this.container.classList.add("playing--video");
          }
          clearInterval(addClassInterval);
        }
      }, 500);

      if (this.querySelector("[data-postervideo]")) this.managePosterVideos();
      if (
        this.placementType == "grid" &&
        (this.type == "local" || this.type == "youtube")
      ) {
        this.videoPauseOnScroll();
      }
    }
  }

  /**
   *
   * Create the video html element
   */
  _buildVideo() {
    let video;

    if (this.type == "local") {
      // console.log(this.dataset.autoplay);
      video = document.createElement("video");
      video.src = this.videoURL;
      if (this.dataset.controls == "true")
        video.controls = this.dataset.controls;
      if (this.dataset.muted == "true") video.muted = this.dataset.muted;
      if (this.dataset.autoplay == "true")
        video.autoplay = this.dataset.autoplay;
      if (this.dataset.loop == "true") video.loop = this.dataset.loop;
      video.playsInline = true;
    } else if (this.type == "youtube") {
      let videoID = this.videoURL.replace(
        "https://www.youtube.com/watch?v=",
        ""
      );
      video = document.createElement("iframe");
      video.setAttribute("allowfullscreen", "");
      video.setAttribute("frameborder", "0");
      video.setAttribute(
        "src",
        "https://www.youtube.com/embed/" +
          videoID +
          `?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&mute=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${videoID}&enablejsapi=1&origin=${window.origin}`
      );
      console.log(this.videoURL);
      console.log(video)
    } else if (this.type == "vimeo") {
      let videoID = this.videoURL.replace("https://vimeo.com/", "");
      video = document.createElement("iframe");
      video.setAttribute("allowfullscreen", "");
      video.setAttribute("frameborder", "0");
      if (this.dataset.autoplay) video.setAttribute("allow", "autoplay");
      video.setAttribute(
        "src",
        "https://player.vimeo.com/video/" +
          videoID +
          `?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&mute=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${videoID}`
      );
    }
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
   */
  videoPauseOnScroll() {
    let videoEle =
      this.querySelector(".video-section video") ||
      this.querySelector(".video-section iframe");
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio == 0) {
          if (this.type == "local") {
            videoEle.pause();
          } else if (this.type == "youtube") {
            videoEle.contentWindow.postMessage(
              '{"event":"command","func":"pauseVideo","args":""}',
              "*"
            );
          }
        }
      });
    });
    observer.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
   */
  managePosterVideos() {
    let posterVideo = this.querySelector("[data-postervideo]");
    if (!posterVideo) return;

    const onIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          let dataSrc = entry.target.dataset.src;
          var videoSource = document.createElement("source");
          videoSource.src = dataSrc;
          videoSource.type = "video/mp4";
          entry.target.appendChild(videoSource);
          entry.target.play();
          observerPosterVideo.disconnect();
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(onIntersection);
    if (posterVideo != undefined) observerPosterVideo.observe(posterVideo);
  }
}
customElements.define("custom-video", customVideo);

/**
 * Open Modal javscript trigger
 *
 * */
function openModal(modal, opener) {
  if (modal && opener != undefined) modal.show(opener);
}

/**
 * Modal Dialogue
 *
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector(".modal");
    this.modalOpeners = document.querySelectorAll(
      '[data-modal-opener="' + this.id + '"]'
    );
  }

  connectedCallback() {
    if (this.modalOpeners.length > 0) {
      this.modalOpeners.forEach((opener) => {
        opener.addEventListener("click", () => {
          this.show(opener);
        });
      });
    }

    const closeButtons = this.querySelectorAll('[id^="ModalClose-"]');

    closeButtons.forEach(button => {
      button.addEventListener("click", this.hide.bind(this));
    });

    this.addEventListener("click", (evt) => {
      if (evt.target.nodeName === "MODAL-DIALOG") this.hide();
    });

    this.addEventListener("keyup", (evt) => {
      if (evt.code.toUpperCase() === "ESCAPE") this.hide();
    });
  }

  /**
   * Open the Modal
   * @param {element} opener
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add("open");
    siteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.querySelector('[id^="ModalClose-"]'));
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.modal.classList.remove("open");
    siteOverlay.prototype.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);

    if (this.id == "PopupModal-video") {
      this.querySelector(".video-container").innerHTML = "";
    }
  }
}
customElements.define("modal-dialog", ModalDialog);


/**
 * Make it alive modal
 *
 */
class ModalDialogAlive extends ModalDialog {

  show(opener) {

    let makeItAliveInput = opener.querySelector("[data-make-it-alive]");

    // Check if the make it alive input is already checked. In this case we don't want to open the modal.
    // Since the user already confirmed the make it alive option, they don't need to see the modal again.
    // This will just uncheck the input and disable it again. Otherwise, open normally.
    if (makeItAliveInput && makeItAliveInput.checked) {
      makeItAliveInput.checked = false;
      makeItAliveInput.setAttribute("disabled", true);
      // $(opener).closest('product-form').find("[data-minigame-select]").slideUp({duration : 300});
    } else {
      super.show(opener);
    }

  }


}
customElements.define("modal-dialog-alive", ModalDialogAlive);


/**
 * Manage Custom Notification Trigger
 *
 */
class Notification extends HTMLElement {
  constructor() {
    super();

    this.paused = false;
    this.container = this.querySelector(".snotifyToast");
    this.closeBtn = this.querySelector(".snotifyToast__close");
  }

  connectedCallback() {
    this.container.addEventListener("mouseover", (event) => {
      this.paused = true;
    });
    this.container.addEventListener("mouseout", (event) => {
      this.paused = false;
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.container.classList.remove("open");
        this.querySelector(".snotifyToast__title").innerHTML = "";
        this.querySelector(".snotifyToast__body").innerHTML = "";
        this.container.classList.remove(
          "snotify-warning",
          "snotify-info",
          "snotify-error",
          "snotify-success"
        );
        this.querySelector("[data-toast-pr]").removeAttribute("style");
      });
    }
  }

  /**
   * Notification Type
   * @param title
   * @param body
   * @param options
   */
  updateNotification(title, body, options) {
    this.container.className = "";
    this.querySelector(".snotifyToast__title").innerHTML = title;
    this.querySelector(".snotifyToast__body").innerHTML = body;

    this.container.classList.add("snotifyToast");
    if (options.type == "error") {
      this.container.classList.add("snotify-error");
    } else if (options.type == "warning") {
      this.container.classList.add("snotify-warning");
    } else if (options.type == "info") {
      this.container.classList.add("snotify-info");
    } else if (options.type == "success") {
      this.container.classList.add("snotify-success");
    }

    this.container.classList.add("open");
    this.manageToggle(options.timeout);
  }

  /**
   * Duration of notification to hide again
   * @param timeout
   */
  manageToggle(timeout) {
    this.progressBar = this.querySelector("[data-toast-pr]");
    let unit = parseInt(timeout) / 1000;
    unit = 100 / unit;
    let width = 0;

    let interval = setInterval(() => {
      if (this.paused == false) {
        width += unit;
        this.progressBar.setAttribute("style", `width: ${width}%`);
        if (width > 100) {
          this.closeBtn.dispatchEvent(new Event("click"));
          clearInterval(interval);
        }
      }
    }, 1000);
  }
}
customElements.define("custom-notification", Notification);
window.notificationEle = document.querySelector("custom-notification");
// notificationEle.updateNotification('Title', 'Body', {
//   type: 'success',
//   timeout: 10000
// });

window.onscroll = function () {
  stickyHeader();
};

var header = document.querySelector(".section-header");
var topbar = document.querySelector(".topbar");

var sticky = topbar.clientHeight;

function stickyHeader() {
  if (window.pageYOffset > sticky) {
    header.classList.add("is-pinned");
  } else {
    header.classList.remove("is-pinned");
  }
}

setTimeout(() => {
  updateTopinRoot();
}, 300);
function updateTopinRoot() {
  let headerEle = document.querySelector(".section-header");
  if (headerEle != undefined) {
    let headerHeight = headerEle.clientHeight;
    document
      .querySelector(":root")
      .style.setProperty("--bs-navdrawer", `${headerHeight}px`);
    document
      .querySelector(":root")
      .style.setProperty("--bs-mobile-navdrawer", `${headerHeight}px`);
  }
  let topbarEle = document.querySelector(".topbar");
  if (topbarEle != undefined) {
    let topbarHeight = topbarEle.clientHeight;
    document.documentElement.style.setProperty(
      "--bs-topbar-height",
      `${topbarHeight}px`
    );
  }
}

gsap.registerPlugin(ScrollTrigger);

const lenis = new Lenis();

// lenis.on('scroll', (e) => {
//   console.log(e)
// })

lenis.on("scroll", ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);

// lenish

var parallax_img = gsap.utils.toArray(".parallax_img");

parallax_img.forEach((text, index) => {
  var moveUpElements = text.querySelectorAll("[move_img='up']");
  moveUpElements.forEach((element) => {
    gsap.to(element, {
      y: "200%",
      duration: 0.5,
      ease: "power1.out",
      scrollTrigger: {
        trigger: text,
        // markers: true,
        end: index === 0 ? "bottom 15%" : "bottom 0%",
        start: index === 0 ? "bottom 700px" : "top 100%",
        scrub: 1,
        // toggleActions: "play reverse play reset",
      },
    });
  });
});

parallax_img.forEach((text, index) => {
  var moveDownElements = text.querySelectorAll("[move_img='down']");
  moveDownElements.forEach((element) => {
    gsap.to(element, {
      y: "-200%",
      duration: 0.5,
      ease: "power1.out",
      scrollTrigger: {
        trigger: text,
        // markers: true,
        end: index === 0 ? "bottom 15%" : "bottom 0%",
        start: index === 0 ? "bottom 700px" : "top 100%",
        scrub: 1,
        // toggleActions: "play reverse play reset",
      },
    });
  });
});

var wave_animations = gsap.utils.toArray(".wave_animation");

wave_animations.forEach((wave_animation, index) => {
  var animating = wave_animation.querySelectorAll(".animating");
  animating.forEach((element) => {
    gsap.to(element, {
      backgroundPositionX: "65vh",
      duration: 0.5,
      ease: "power1.out",
      scrollTrigger: {
        trigger: wave_animation,
        //markers: true,
        end: index === 0 ? "bottom -0%" : "bottom -0%",
        start: index === 0 ? "top 100%" : "top 100%",
        scrub: true,
      },
    });
  });
});

var aos_img = gsap.utils.toArray("[data-aos]");
aos_img.forEach((element) => {
  gsap.to(element, {
    scrollTrigger: {
      trigger: element,
      start: "top 98%", // adjust as needed
      toggleClass: { targets: element, className: "aos-animate" },
      // markers: true,
      once: true,
    },
  });
});

// setTimeout(() => {
//   AOS.init(
//     {
//       duration: 500,
//     }
//   );
// }, 200);

// Target all elements with the class "typewriter"
const typewriters = document.querySelectorAll(".typewriter");

// Iterate through each typewriter element
typewriters.forEach((typewriter) => {
  // Get the text content of the typewriter element
  const text = typewriter.textContent.trim();

  // Clear the text content of the typewriter element
  typewriter.textContent = "";

  // Create a timeline animation with GSAP
  const tl = gsap.timeline({ paused: true });

  // Iterate through each character in the text
  for (let i = 0; i < text.length; i++) {
    // Add each character to the timeline with a typewriter effect
    tl.to(typewriter, {
      textContent: text.substring(0, i + 1), // Update text content with each character
      duration: 0.1, // Typing speed (adjust as needed)
      ease: "none", // Linear easing for a constant typing speed
    });
  }

  // Use ScrollTrigger to trigger the animation when the element enters the viewport
  ScrollTrigger.create({
    trigger: typewriter,
    start: "top 98%", // Adjust as needed
    onEnter: () => {
      // Start the animation when the element enters the viewport
      tl.play();
    },
    onLeaveBack: () => {
      // Reverse the animation when the element leaves the viewport
      tl.reverse();
    },
    //markers: true, // For debugging, remove this line in production
  });
});

// // Ensure GSAP and ScrollTrigger are loaded
// document.addEventListener('DOMContentLoaded', () => {
//   // Register ScrollTrigger plugin
//   gsap.registerPlugin(ScrollTrigger);

//   // Select the "add to cart" button
//   const addToCartButton = document.getElementById('add-to-cart');

//   // Create a ScrollTrigger instance
//   ScrollTrigger.create({
//     trigger: addToCartButton,
//     markers: true,
//     start: 'top bottom', // When the top of the button enters the bottom of the viewport
//     end: 'bottom top',   // When the bottom of the button exits the top of the viewport
//     toggleClass: {
//       targets: addToCartButton,
//       className: 'visible'
//     },
//     onEnter: () => console.log('Button entered the viewport'),
//     onLeave: () => console.log('Button left the viewport'),
//     onEnterBack: () => console.log('Button re-entered the viewport from the bottom'),
//     onLeaveBack: () => console.log('Button exited the viewport from the top')
//   });
// });

  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 && // Top of the element is within the viewport
      rect.left >= 0 && // Left of the element is within the viewport
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) && // Bottom of the element is within the viewport
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) // Right of the element is within the viewport
    );
  }

  window.addEventListener("scroll", () => {
    const startCustomizingButton = document.querySelector(".start_customizing");
    const innerStartCustomizingButton = document.querySelector(
      ".start_customizing .btn"
    );

    if (startCustomizingButton && innerStartCustomizingButton) {
      if (isElementInViewport(startCustomizingButton)) {
        startCustomizingButton.classList.add("visible");
      } else {
        startCustomizingButton.classList.remove("visible");
      }
    }
  });

  
// instafeed
  // Check if the element with ID "insta-feed" exists
  setTimeout(() => {
    if (document.getElementById('insta-feed')) {
      // Add click event listeners to elements with the class "instafeed-hover-layer"
      document.querySelectorAll('.instafeed-hover-layer').forEach(element => {
          element.addEventListener('click', () => {
              document.body.setAttribute('data-lenis-prevent', '');
          });
      });
    
      // Create a MutationObserver to watch for class changes on the body element
      const observer = new MutationObserver((mutationsList) => {
          mutationsList.forEach((mutation) => {
              if (mutation.attributeName === 'class' && !document.body.classList.contains('instafeed-body-no-scroll')) {
                  // If the 'instafeed-body-no-scroll' class is removed, remove the 'data-lenis-prevent' attribute
                  document.body.removeAttribute('data-lenis-prevent');
              }
          });
      });
    
      // Start observing the body element for attribute changes (specifically class changes)
      observer.observe(document.body, { attributes: true });
    }
  }, 1000);

document.querySelectorAll("a[href*='tradeshowbooth.com']").forEach(function(linkElem){
  const currentURL = new URL(linkElem.href);
  currentURL.searchParams.set("utm_source",'backdrop');
  linkElem.href=currentURL.href;
});
